import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import './App.css';
import whitepaper from './whitepaper.md';

function App() {
  const [markdownContent, setMarkdownContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch the markdown content
    fetch(whitepaper)
      .then(response => response.text())
      .then(text => {
        setMarkdownContent(text);
        setLoading(false);
      });
  }, []);

  return (
    <Router>
      <div className="App ltr">
        <header className="App-header">
          <div className="logo-container">
            <img src="/teos_logo.png" alt="TEOS Logo" className="logo" />
            <h1>$TEOS Egypt Whitepaper</h1>
          </div>
        </header>
        <nav className="App-nav">
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/whitepaper">Whitepaper</Link></li>
            <li><a href="https://www.dexlab.space/token-hub/AhXBUQmbhv9dNoZCiMYmXF4Gyi1cjQthWHFhTL2CJaSo" target="_blank" rel="noopener noreferrer">Token Hub</a></li>
            <li><a href="https://solana.com/" target="_blank" rel="noopener noreferrer">Solana</a></li>
          </ul>
        </nav>
        <main className="App-content">
          <Routes>
            <Route path="/" element={
              <div className="home-content">
                <h1>$TEOS Egypt</h1>
                <h2>Revolutionizing Cultural Heritage Engagement with AI and IoT</h2>
                <p>Welcome to the official $TEOS Egypt whitepaper. Explore how we are integrating AI and IoT technologies to create an interactive, personalized, and rewarding ecosystem centered on Egyptian cultural heritage.</p>
                <div className="cta-buttons">
                  <Link to="/whitepaper" className="cta-button">Read Whitepaper</Link>
                  <a href="https://www.dexlab.space/token-hub/AhXBUQmbhv9dNoZCiMYmXF4Gyi1cjQthWHFhTL2CJaSo" target="_blank" rel="noopener noreferrer" className="cta-button">View Token Hub</a>
                </div>
              </div>
            } />
            <Route path="/whitepaper" element={
              <div className="whitepaper-content">
                {loading ? (
                  <p>Loading whitepaper...</p>
                ) : (
                  <ReactMarkdown>{markdownContent}</ReactMarkdown>
                )}
              </div>
            } />
          </Routes>
        </main>
        <footer className="App-footer">
          <div className="footer-content">
            <div className="contact-info">
              <h3>Contact Information</h3>
              <p><strong>Telegram:</strong> @elmahrosapi</p>
              <p><strong>WhatsApp:</strong> +201006167293</p>
              <p><strong>Email:</strong> info@elmahrosa-expo.com</p>
            </div>
            <div className="copyright">
              <p>&copy; {new Date().getFullYear()} Elmahrosa International E.S.T. All rights reserved.</p>
            </div>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
